import React from 'react'

const Hamburger = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47 10" aria-hidden="true">
    <rect
      className="hamburger-bar--top"
      width="36"
      height="3"
      x="0"
      y="0"
      fill="currentColor"
    />
    <rect width="47" height="3" x="0" y="7" fill="currentColor" />
  </svg>
)

export default Hamburger
